(function () {
  if (window.__facetsVendorSearchInit) {
    return;
  }

  window.__facetsVendorSearchInit = true;

  const searchQueries = new Map();

  function getSearchKey(input) {
    return input.id || "vendor-search";
  }

  function filterVendorList(input) {
    const root = input.closest("[data-facets-vendor-list]");

    if (!root) {
      return;
    }

    const query = input.value.trim().toLowerCase();
    const items = root.querySelectorAll("[data-facets-vendor-item]");
    const empty = root.querySelector("[data-facets-vendor-empty]");
    let visibleCount = 0;

    searchQueries.set(getSearchKey(input), input.value);

    items.forEach((item) => {
      const label = item.dataset.label || "";
      const isMatch = query === "" || label.includes(query);
      item.hidden = !isMatch;

      if (isMatch) {
        visibleCount += 1;
      }
    });

    if (empty) {
      empty.hidden = visibleCount > 0;
    }
  }

  function restoreVendorSearches() {
    document.querySelectorAll("[data-facets-vendor-search]").forEach((input) => {
      const stored = searchQueries.get(getSearchKey(input));

      if (stored) {
        input.value = stored;
      }

      if (input.value) {
        filterVendorList(input);
      }
    });
  }

  document.addEventListener(
    "change",
    (event) => {
      if (event.target.closest("[data-facets-vendor-search]")) {
        event.stopPropagation();
      }
    },
    true,
  );

  document.addEventListener("input", (event) => {
    const input = event.target.closest("[data-facets-vendor-search]");

    if (!input) {
      return;
    }

    filterVendorList(input);
  });

  document.addEventListener("click", (event) => {
    const clear = event.target.closest("[data-facets-vendor-search-clear]");

    if (!clear) {
      return;
    }

    event.preventDefault();

    const root = clear.closest("[data-facets-vendor-list]");
    const input = root?.querySelector("[data-facets-vendor-search]");

    if (!input) {
      return;
    }

    input.value = "";
    filterVendorList(input);
    input.focus();
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Enter" &&
      event.target.closest("[data-facets-vendor-search]")
    ) {
      event.preventDefault();
    }
  });

  document.addEventListener("theme:loading:end", restoreVendorSearches);
})();
